import React from 'react';
import { formatSessionTimes } from '../../lib/pmEventTime';

/**
 * Session time in its own zone (emphasized) plus ET / CT / PT underneath.
 * Other zones share one line on desktop and stack on narrow screens.
 */
export default function SessionTimes({ startsAt, endsAt, timezone, showDate = true, className = '' }) {
  const times = formatSessionTimes(startsAt, endsAt, timezone);
  if (!times) return <span className="text-gray-400">—</span>;

  return (
    <div className={className}>
      {showDate && <div className="text-sm text-gray-600">{times.primary.dateLabel}</div>}
      <div className="text-base font-semibold text-gray-900">{times.primary.timeRangeLabel}</div>
      {times.others.length > 0 && (
        <div className="flex flex-col sm:flex-row sm:flex-wrap sm:gap-x-1 text-xs text-gray-500">
          {times.others.map((o, i) => (
            <span key={o.tz} className="whitespace-nowrap">
              {i > 0 && <span className="hidden sm:inline" aria-hidden="true">· </span>}
              {o.timeRangeLabel}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
